"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpecificConditionsGroupName = exports.getConditionsGroupName = void 0;
var _fp = require("lodash/fp");
var _conditionFilter = _interopRequireDefault(require("./condition-filter"));
var _flatMapDeep = _interopRequireDefault(require("../../utils/flat-map-deep"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getConditionsName = function getConditionsName(offer, path) {
  return (0, _fp.head)((0, _fp.uniqBy)('value', (0, _flatMapDeep["default"])(offer, path, _conditionFilter["default"]))) || null;
};
var getConditionsGroupName = exports.getConditionsGroupName = function getConditionsGroupName(offer) {
  return getConditionsName(offer, 'offerTypes.hasConditionsGroup.containsConditions');
};
var getSpecificConditionsGroupName = exports.getSpecificConditionsGroupName = function getSpecificConditionsGroupName(offer) {
  return getConditionsName(offer, 'offerTypes.hasSpecificConditions');
};